import * as React from "react";
import { KeyboardContext } from "./keyboardContext";

export interface KeyboardButtonDefinition {
    readonly char: string;
}

export interface KeyboardButtonProps {
    readonly button: KeyboardButtonDefinition;
}

export function KeyboardButton({
    button,
    ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & KeyboardButtonProps) {
    // tslint:disable:jsx-no-lambda
    return (
        <KeyboardContext.Consumer>
            {event => <button {...props} onClick={() => event(button)} />}
        </KeyboardContext.Consumer>
    );
    // tslint:enable:jsx-no-lambda
}
